import { useCurrentCompany } from './use-current-company';
import { useFeatureFlag } from './use-feature-flag';

/**
 * Feature flag name for mimicking Bonusly company behavior.
 * When enabled for a user, they get access to Bonusly-internal features
 * even if they're not part of the actual Bonusly company.
 */
const MIMIC_BONUSLY_FLAG = 'mimic-bonusly';

/**
 * Hook to determine if the current context should be treated as "Bonusly company".
 *
 * Returns true if:
 * - The company is the actual Bonusly company (is_bonusly_company from API), OR
 * - The current user has the 'mimic-bonusly' feature flag enabled
 *
 * This allows Bonusly engineers to test internal features on non-Bonusly companies.
 */
export function useIsBonuslyCompany(): boolean {
	const company = useCurrentCompany();
	const hasMimicFlag = useFeatureFlag(MIMIC_BONUSLY_FLAG);

	// True if actual Bonusly company OR user has mimic flag
	return company?.is_bonusly_company === true || hasMimicFlag;
}
